// extracted by mini-css-extract-plugin
export default {"input-container":"Checkbox_input-container__9hmXh","checkbox":"Checkbox_checkbox__fq9hd","checkbox-label":"Checkbox_checkbox-label__59GEW","check":"Checkbox_check__T-8Xf"};